import React, { useEffect, useMemo, useRef, useState } from 'react'
import './index.scss'
import { debounce } from 'lodash'
import clsx from 'clsx'
import { ICONS } from '@Const/common'

interface InputProps {
    mainColor: boolean
    id: string
    type: 'submit' | 'sign-up' | 'work-search'
    onChange: (value: string, id: string) => void
    value?: string
    errorMessage?: string
    title: string
    clear?: boolean
    disabled?: boolean
    helperText?: string
    onKeyPress?: (e: any) => void
}

const Input = ({
    mainColor,
    id,
    type,
    onChange,
    value,
    errorMessage,
    title,
    clear,
    disabled,
    helperText,
    onKeyPress,
}: InputProps) => {
    const [inputValue, setInputValue] = useState(value || '')
    const [activeInputState, setActiveInputState] = useState(false)
    const inputValueRef = useRef(inputValue)
    inputValueRef.current = inputValue
    const isFirstRender = useRef(true)

    const onFocusInput = () => setActiveInputState(true)

    const onBlurInput = () => setActiveInputState(false)

    const onSave = useMemo(
        () =>
            debounce(() => {
                onChange(inputValueRef.current, id)
            }, 200),
        [onChange, id]
    )

    const handleChange = (event: any) => {
        setInputValue(event.target.value)
        onSave()
    }

    const cleanChange = () => {
        setInputValue('')
        onSave()
    }

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false
            return
        }
        if (clear) {
            cleanChange()
        }
    })

    const classNames = clsx(
        'input-component',
        mainColor ? 'main-color-set' : 'second-color-set',
        type,
        activeInputState && 'focused',
        inputValue && 'filled',
        errorMessage && 'error'
    )

    return (
        <div className={classNames}>
            <p className="small-2 medium" title={title}>
                {title}
            </p>
            <div className="input-wrapper">
                <input
                    type="text"
                    id={id}
                    value={inputValue}
                    onBlur={onBlurInput}
                    onFocus={onFocusInput}
                    onChange={handleChange}
                    disabled={!!disabled}
                    placeholder={!activeInputState ? title : ''}
                    onKeyPress={onKeyPress}
                />
                {inputValue && <img onClick={cleanChange} className="remove-value" src={ICONS.close} alt="close" />}
            </div>
            {errorMessage ? (
                <p className="error-text small">{errorMessage}</p>
            ) : helperText ? (
                <p className="basic-input-helper-text small">{helperText}</p>
            ) : null}
        </div>
    )
}

export default Input
